import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from '@/types';

import user from './modules/user';
import products from './modules/products';
import ui from './modules/ui';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  // do not enable strict mode when deploying for production! (see https://vuex.vuejs.org/guide/strict.html)
  // strict: true,
  modules: {
    user,
    products,
    ui,
  },
};

export default new Vuex.Store<RootState>(store);



// WEBPACK FOOTER //
// ./src/store/index.ts